function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "awesome-instagram",
  "data-name": "Icon awesome-instagram",
  d: "M36.086,19.814a18.5,18.5,0,1,0,18.5,18.5A18.469,18.469,0,0,0,36.086,19.814Zm0,30.525A12.026,12.026,0,1,1,48.112,38.313,12.048,12.048,0,0,1,36.086,50.339Zm23.57-31.282a4.315,4.315,0,1,1-4.315-4.315A4.3,4.3,0,0,1,59.656,19.058Zm12.252,4.379c-.274-5.78-1.594-10.9-5.828-15.118C61.862,4.1,56.742,2.781,50.962,2.491c-5.957-.338-23.811-.338-29.768,0C15.43,2.765,10.311,4.085,6.076,8.3S.538,17.641.248,23.421c-.338,5.957-.338,23.811,0,29.768.274,5.78,1.594,10.9,5.828,15.118s9.338,5.538,15.118,5.828c5.957.338,23.811.338,29.768,0,5.78-.274,10.9-1.594,15.118-5.828,4.218-4.218,5.538-9.338,5.828-15.118.338-5.957.338-23.8,0-29.752Zm-7.7,36.144a12.176,12.176,0,0,1-6.858,6.858c-4.749,1.884-16.019,1.449-21.268,1.449s-16.534.419-21.268-1.449A12.176,12.176,0,0,1,7.96,59.581C6.076,54.831,6.511,43.561,6.511,38.313S6.092,21.779,7.96,17.045a12.176,12.176,0,0,1,6.858-6.858C19.568,8.3,30.838,8.738,36.086,8.738s16.534-.419,21.268,1.449a12.176,12.176,0,0,1,6.858,6.858c1.884,4.749,1.449,16.019,1.449,21.268S66.1,54.847,64.212,59.581Z",
  transform: "translate(0.005 -2.238)",
  fill: "#fff"
});

var SvgAwesomeInstagram = function SvgAwesomeInstagram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 72.167,
    height: 72.151,
    viewBox: "0 0 72.167 72.151",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAwesomeInstagram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/awesome-instagram.c084c7e0.svg";
export { ForwardRef as ReactComponent };